// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import HttpService from 'src/lib/HttpService';


const DEVICE_EXTENSION_URL = `api/ustrl/v1.0/warranty/variant/VARIANT`;
const DEVICE_PROOF_OF_PURCHASE_URL = `api/ustrl/v3.0/device/Microsoft`;

interface ExtensionLookUp {
    AgentEmail: string;
    Manufacturer: string;
    Reason: string;
    SerialNumber: string;
    UserGroup: string;
}
interface ProofOfPurchaseLookUp {
    AgentEmail: string;
    ImageMimeType: string | null;
    Notes: string;
    OrderId: string | null;
    PurchaseDate: string;
    ReceiptImage: string | null;
    StoreId: string | null;
}

export default {
    async postExtensionWarrantyUpdate({ body, extension }: { body: ExtensionLookUp; extension: string; }) {
        const response = await HttpService.proxiedApiCall({
            body,
            requestUrl: `${DEVICE_EXTENSION_URL}/${extension}/fulfill`,
            type: 'post',
        });
        return response;
    },
    async postProofOfPurchaseWarrantyUpdate(body: ProofOfPurchaseLookUp, extension: string, serialNumber: string) {
        const response = await HttpService.proxiedApiCall({
            body,
            requestUrl: `${DEVICE_PROOF_OF_PURCHASE_URL}/${serialNumber}/proofofpurchase`,
            type: 'post',
        });
        return response;
    },

};
